import type { AxiosResponse } from "axios";

const createFileDownloadLink = (response: AxiosResponse<Blob>, downloadFilename: string) => {
    // Создаем ссылку для скачивания
    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;

    // Имя файла из заголовков ответа или используем переданное
    const contentDisposition = response.headers["content-disposition"];

    if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (filenameMatch && filenameMatch[1]) {
            downloadFilename = filenameMatch[1].replace(/['"]/g, "");
        }
    }

    link.setAttribute("download", downloadFilename);
    document.body.appendChild(link);
    link.click();

    // Очистка
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};

export default createFileDownloadLink;